import { DefaultContainer } from '@/components/DefaultContainer';
import { Avatar, Box, Container, Grid, Link, List, ListItem, ListItemAvatar, ListItemText, Typography } from '@mui/material';

const appName = 'Witness the Fitness';

export const Support = () => {
  return (
    <DefaultContainer>
      <Typography sx={{ mt: 3, textAlign: 'center' }} variant="h3" gutterBottom>
        Need Support?
      </Typography>
      <Typography sx={{ textAlign: 'center', mt: 5 }} gutterBottom>
        Feel free to contact me for any Questions, Feature Requests or Issues regarding "{appName}"
      </Typography>
      <Box sx={{ m: 3 }}>
        <Typography sx={{ textAlign: 'center' }}>
          Enter our discord channel: <Link href={'https://discord.gg/V52ATXsU'}>https://discord.gg/V52ATXsU</Link>
        </Typography>
        <Typography sx={{ textAlign: 'center' }}>Sebastian Sippl</Typography>
        <Typography sx={{ textAlign: 'center' }}>Hofzeile 7-9/1/3</Typography>
        <Typography sx={{ textAlign: 'center' }}>1190 Vienna, Austria</Typography>
        <Typography sx={{ textAlign: 'center' }}>Phone: +43 677 62832242</Typography>
        <Typography sx={{ textAlign: 'center' }}>
          <Link href="mailto:ssippl.fitness@gmail.com">ssippl.fitness@gmail.com</Link>
        </Typography>
      </Box>
    </DefaultContainer>
  );
};
